import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LegendComponent } from "../../../../../../common/components/legend_component";
import { LegendTagIcon } from "../../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../../common/components/legend_tag_item_component";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const LegendaModal = ({
  open,
  onClose
}: Props) => {
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "35rem",
          },
        },
      }}>
      <DialogTitle>
        Legenda
      </DialogTitle>

      <DialogContent>
        <div className="flex flex-col flex-wrap">
          <LegendComponent label="Documentos">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='blue' title='DE' />}
              label='Documentos Em Dia' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='DV' />}
              label='Documentos Vencido' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='yellow' title='ND' textColor='white'/>}
              label='Não possui Documentos' />

          </LegendComponent>

          <LegendComponent label=" Avaliação de treinamento">
            <div>
                <LegendTagItemComponent
                  icon={<LegendTagIcon color='gray' title='NT' />}
                  label='Não possui treinamentos' />

                <LegendTagItemComponent
                  icon={<LegendTagIcon color='red' title='AT' />}
                  label='Atraso' />
            </div>
            <div>
              <LegendTagItemComponent
                icon={<LegendTagIcon color='blue' title='AC' />}
                label='Concluídas' />

              <LegendTagItemComponent
                icon={<LegendTagIcon color='yellow' title='TNR' textColor='white'/>}
                label='Não realizados' /> 
            </div>

          </LegendComponent>

          <LegendComponent label="ASO">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='red' title='Não' />}
              label='Não' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='blue' title='Sim' />}
              label='Sim' />

          </LegendComponent>

          <LegendComponent label="Status">
            <LegendTagItemComponent
              icon={<LegendTagIcon color='gray' title='I' />}
              label='Inativo' />

            <LegendTagItemComponent
              icon={<LegendTagIcon color='blue' title='A' />}
              label='Ativo' />

          </LegendComponent>
        </div>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={onClose}>
                Fechar
              </h1>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}